module.exports = __webpack_public_path__ + "static/media/personFlying-Light.a90d6a69.gif";